module.exports = __webpack_public_path__ + "media/images/icons/testimonials-c21b994ffa9f602dcab9d5df508cd2cb.svg";